import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Entry } from 'contentful';

import { GlobalContentService } from '../../services/global-content/global-content.service';
import { MetaService } from '../../services/meta/meta.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  public content: Entry<any> | undefined;
  public globalContent$: Observable<Entry<any>>;

  constructor(
    private globalContentService: GlobalContentService,
    activatedRoute: ActivatedRoute,
    meta: MetaService
  ) {
    this.content = activatedRoute.snapshot.data.content;
    if (this.content && this.content.fields.seo) {
      meta.updateMetaTags(this.content.fields.seo);
    }
  }

  ngOnInit() {
    this.globalContent$ = this.globalContentService.getGlobalContent();
  }
}
